import { message } from 'antd';
import RestCrudThunks from './restCrudThunksGenerator';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { ROLE_TYPES } from '../utils/DataConstants';
import { logoutSuccess } from '../actions/session_actions';
import { WORK_ORDER_LABELS_CRUD_ACTION_CREATORS } from '../actions/work_order_labels_actions';

const fetchUtils = new FetchUtils();

// ---------------------------------------------------------------------------
// Label catalogue CRUD — list / create / update / delete.
// The generator's URL shapes match the backend exactly:
//   GET/POST    /api/v1/{role}/work_order/work_order_labels
//   PUT         /api/v1/{role}/work_order/work_order_labels        (id in body)
//   GET/DELETE  /api/v1/{role}/work_order/work_order_labels/:id
// ---------------------------------------------------------------------------

export const workOrderLabelsRestCrudThunksForBuyer = new RestCrudThunks(
	'work_order_labels',
	'work_order_label',
	'workOrderLabel',
	'workOrderLabels',
	WORK_ORDER_LABELS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const workOrderLabelsRestCrudThunksForSupplier = new RestCrudThunks(
	'work_order_labels',
	'work_order_label',
	'workOrderLabel',
	'workOrderLabels',
	WORK_ORDER_LABELS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);

export const workOrderLabelsRestCrudThunks = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? workOrderLabelsRestCrudThunksForSupplier
		: workOrderLabelsRestCrudThunksForBuyer;

// ---------------------------------------------------------------------------
// Label assignment — PUT /work_order/work_orders/:woId/labels  { ids: [...] }
// Returns OkResponseSeq[WorkOrderLabelMapping]. This is not a standard CRUD
// route, so it is a hand-written thunk rather than part of the generator.
// ---------------------------------------------------------------------------
const updateWorkOrderLabelsForRole =
	(roleType: string) => (workOrderId: number | string, labelIds: number[]) => {
		const apiUrl = `${getBackendUri()}/api/v1/${roleType}/work_order/work_orders/${workOrderId}/labels`;
		return (dispatch) =>
			new Promise((resolve, reject) => {
				fetchUtils
					.put(apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { ids: labelIds },
					})
					.then(parseJSON)
					.then((result) => {
						const status = result.status;
						const ok = result.ok;
						const json = result.json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (!ok || (json && json.status === 'error')) {
							message.error('Failed to update labels for this work order.');
							reject(
								json && json.message ? json.message : 'Failed to update labels for this work order.'
							);
						} else {
							resolve(json && json.data !== undefined ? json.data : json);
						}
					})
					.catch((error) => {
						message.error('Failed to update labels for this work order.');
						reject(error && error.message);
					});
			});
	};

export const updateWorkOrderLabelsForBuyer = updateWorkOrderLabelsForRole(ROLE_TYPES.BUYER);
export const updateWorkOrderLabelsForSupplier = updateWorkOrderLabelsForRole(ROLE_TYPES.SUPPLIER);

export const updateWorkOrderLabels = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? updateWorkOrderLabelsForSupplier
		: updateWorkOrderLabelsForBuyer;
